
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-charcoal text-white relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-5">
        <i className="ri-quill-pen-line text-[400px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></i>
      </div>

      {/* Upper Footer */}
      <div className="relative px-8 lg:px-16 pt-20 pb-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Left Column - Newsletter */}
          <div className="lg:col-span-5">
            <h3 className="font-playfair text-3xl mb-2">
              SUSAN GITELSON<span className="text-burgundy">.</span>
            </h3>
            <p className="text-lg font-playfair text-white/90 mb-6 leading-relaxed">
              STAY UPDATED WITH<br />NEW RELEASES
            </p>
            <div id="newsletter" className="flex gap-3 max-w-md">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-1 px-4 py-3 bg-transparent border border-white/30 rounded-lg text-white placeholder:text-white/50 focus:outline-none focus:border-burgundy transition-colors"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-burgundy rounded-lg hover:bg-burgundy/90 transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </button>
            </div>
          </div>

          {/* Right Columns - Navigation */}
          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-lato text-white mb-4 text-sm tracking-wider">EXPLORE</h4>
              <ul className="space-y-3">
                <li><Link to="/books" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">All Books</Link></li>
                <li><a href="#latest" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Latest Release</a></li>
                <li><a href="#reviews" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Book Reviews</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-lato text-white mb-4 text-sm tracking-wider">ABOUT</h4>
              <ul className="space-y-3">
                <li><Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Biography</Link></li>
                <li><a href="#philosophy" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Writing Philosophy</a></li>
                <li><a href="#press" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Press Kit</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-lato text-white mb-4 text-sm tracking-wider">CONNECT</h4>
              <ul className="space-y-3">
                <li><Link to="/contact" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Contact Form</Link></li>
                <li><a href="#speaking" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Speaking Requests</a></li>
                <li><a href="#bookclubs" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Book Clubs</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-lato text-white mb-4 text-sm tracking-wider">RESOURCES</h4>
              <ul className="space-y-3">
                <li><a href="#guide" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Reading Guide</a></li>
                <li><a href="#events" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Author Events</a></li>
                <li><a href="#archive" className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer">Newsletter Archive</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="relative border-t border-white/10 px-8 lg:px-16 py-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/60">© 2025 Susan Gitelson. All rights reserved.</p>
          
          <div className="flex items-center gap-6">
            <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-burgundy hover:bg-burgundy/10 transition-all cursor-pointer">
              <i className="ri-instagram-line text-lg"></i>
            </a>
            <a href="https://twitter.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-burgundy hover:bg-burgundy/10 transition-all cursor-pointer">
              <i className="ri-twitter-x-line text-lg"></i>
            </a>
            <a href="https://goodreads.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-burgundy hover:bg-burgundy/10 transition-all cursor-pointer">
              <i className="ri-book-2-line text-lg"></i>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="nofollow noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-white/30 rounded-lg hover:border-burgundy hover:bg-burgundy/10 transition-all cursor-pointer">
              <i className="ri-linkedin-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
